import { Node, Transforms, Path, Editor } from 'slate';
import { hasVoidDescendant } from '../../queries/hasVoidDescendant.mjs';
import { isDocumentElement } from '../../queries/isDocumentRoot.mjs';
import { isElement } from '../../utilities/nodes/elements/isElement.mjs';

const ROOT_PATH = [];

/**
 * Remove nodes with empty text.
 */
const withRemoveEmptyNodes = (editor, plugins) => {
  const types = getRemoveEmptyNodeTypes(plugins);
  const {
    normalizeNode
  } = editor;
  editor.normalizeNode = ([node, path]) => {
    if (isElement(node) && types.includes(node.type) && Node.string(node) === '' &&
    // Void elements don't contain text. If a node contains a void child element, that node should not be removed
    !hasVoidDescendant(editor, path)) {
      Transforms.removeNodes(editor, {
        at: path
      });
      return;
    }
    if (isDocumentElement(node) && !Path.equals(path, ROOT_PATH)) {
      const [_, parentPath] = Editor.parent(editor, path);
      if (!Path.equals(parentPath, ROOT_PATH)) {
        // Pasting content creates extra document elements
        // Unwrap all document elements that are not at the root path
        Transforms.unwrapNodes(editor, {
          at: path
        });
        return;
      }
    }
    normalizeNode([node, path]);
  };
  return editor;
};
function getRemoveEmptyNodeTypes(plugins) {
  return plugins.reduce((acc, plugin) => {
    return plugin.removeEmptyTypes ? [...acc, ...plugin.removeEmptyTypes] : acc;
  }, []);
}

export { withRemoveEmptyNodes };
